import { auth } from "./auth";
import { experimentSteps } from "./experiment-steps";
import { items } from "element-plus-admin/store/modules/items";
import { enums } from "element-plus-admin/store/modules/enums";

export default { auth, experimentSteps, items, enums };
